import { Button, Spinner, Input, Select, SelectItem, ModalHeader, ModalBody, ModalFooter, Modal, ModalContent } from '@nextui-org/react';
import { IconArrowLeft, IconPlus, IconTrash } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import Calendar from '../../../components/calendar';
import moment from 'moment';
import { TeacherGeneralService, TeacherTestsService } from '../../../services';
import { useSelector } from 'react-redux';
import { formatAmount, formatNumber, formatToApi } from '../../../utils';



const ClassManagementCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { form, isLoading, onChange, evaluations, addEvaluation, removeEvaluation, updateEvaluation, onSubmit, lapses, currentLapse, indicators } = useFetchTable(location.state);

  return (
    <div className="flex gap-10">
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <aside className="bg-foreground-200 w-[25%] h-full p-4 rounded-lg flex flex-col gap-4">
        <div className="flex gap-4">
          <IconArrowLeft className="cursor-pointer" onClick={() => navigate('/class-management', { replace: true })} />
          <span className="font-bold text-secondary capitalize">{location?.state?.name} - {location?.state?.school_grade?.name}</span>
        </div>

        <Select
          label="Seleccionar un lapso"
          labelPlacement="outside"
          placeholder="Seleccione"
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={!!form.school_lapse_id ? [form.school_lapse_id] : []}
          onSelectionChange={v => onChange(v.currentKey, 'school_lapse_id')}
        >
          {lapses.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </Select>



        <Calendar
          minValue={currentLapse?.init_date}
          maxValue={currentLapse?.end_date}
          calendarWidth={350}
          value={form.date}
          onChange={(value) => onChange(value, 'date')}
        />

        <Button className='bg-green text-white' onPress={onSubmit}>
          Guardar
        </Button>
      </aside>

      <main className="w-[70%]">
        <div className='flex items-center justify-between'>
          <p>{moment(form.date).isValid() ? moment(form.date).format('D [de] MMMM [de] YYYY') : 'Selecciona una fecha'}</p>
          <Button
            startContent={<IconPlus className='text-white text-xs' />}
            className='bg-green text-white'
            onPress={addEvaluation}
          >
            Nueva evaluación
          </Button>
        </div>

        <div className='mt-10 grid grid-cols-3 gap-8'>
          {evaluations.map((evalData, idx) => (
            <TestForm
              key={evalData.id}
              data={evalData}
              index={idx}
              onUpdate={updateEvaluation}
              onRemove={removeEvaluation}
              indicators={indicators}
            />
          ))}
        </div>
      </main>
    </div>
  );
};

const TestForm = ({ data, onUpdate, onRemove, index, indicators }) => {
  const [selectedItem, setSelectedItem] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setIsOpen(false);
  }

  const openModal = (item) => {
    if (typeof item.id === 'string') {
      onRemove(item.id);
      return
    }
    setSelectedItem(item);
    setIsOpen(true);
  }

  return (
    <div className='rounded-lg p-4 bg-white flex flex-col gap-4 relative'>

      <Modal
        size="sm"
        isOpen={isOpen}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            return (
              <ModalDelete
                test={selectedItem}
                onClose={onClose}
                onDelete={() => {
                  onRemove(selectedItem.id);
                  closeModal();
                }}
              />
            );
          }}
        </ModalContent>
      </Modal>

      <div className='flex justify-between items-center'>
        <p>Evaluación número {index + 1}</p>
        <IconTrash
          className="absolute top-2 right-2 cursor-pointer text-red-500"
          onClick={() => openModal(data)}
        />
      </div>
      <Input
        label="Tema generador"
        labelPlacement="outside"
        placeholder=" "
        radius="sm"
        variant="bordered"
        value={data.theme_generator}
        onChange={(e) => onUpdate(data.id, 'theme_generator', e.target.value)}
      />
      <Input
        label="Nombre de la evaluación"
        labelPlacement='outside'
        placeholder=' '
        radius='sm'
        variant='bordered'
        value={data.name}
        onChange={(e) => onUpdate(data.id, 'name', e.target.value)}
      />
      <Select
        label="Tipo de evaluación / Indicadores"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{ label: 'font-semibold' }}
        disallowEmptySelection={true}
        selectedKeys={!!data.indicator_id ? [data.indicator_id] : []}
        onSelectionChange={v => onUpdate(data.id, 'indicator_id', v.currentKey)}
      >
        {indicators.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
      <Input
        label="Porcentaje"
        labelPlacement='outside'
        placeholder=' '
        radius='sm'
        variant='bordered'
        value={data.percentage}
        onChange={(e) => onUpdate(data.id, 'percentage', e.target.value)}
      />
      <Input
        label="Observaciones"
        labelPlacement='outside'
        placeholder=' '
        radius='sm'
        variant='bordered'
        value={data.observations}
        onChange={(e) => onUpdate(data.id, 'observations', e.target.value)}
      />
    </div>
  );
};


const ModalDelete = ({ test, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar esta evaluación?. Si realizó alguna evaluación, dichos registros se eliminarán también.</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const useFetchTable = (item) => {
  const initialForm = {
    date: '',
    school_year_id: item?.school_grade?.school_year_id,
    school_lapse_id: '',
    subject_id: item?.id,
  };
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [isLoading, setIsLoading] = useState(false);
  const [evaluations, setEvaluations] = useState([]);
  const [lapses, setLapses] = useState([]);
  const [indicators, setIndicators] = useState([]);

  const onChange = (value, target) => {
    setForm(prev => ({ ...prev, [target]: value }));
  };

  const validateCurrentForms = () => {
    return evaluations.every(evaluation =>
      evaluation?.theme_generator?.trim() !== '' &&
      evaluation?.name?.trim() !== '' &&
      evaluation?.indicator_id &&
      evaluation?.percentage?.trim() !== ''
    );
  };

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const getSelects = async () => {
    try {
      const lapsesData = await TeacherGeneralService.generals.getLapses({ user_id: user.id });
      const resData = await TeacherTestsService.tests.getIndicators({
        professor_id: user.id,
        school_year_id: item?.school_grade?.school_year_id,
        subject_id: item?.id,
      });
      setLapses(toSelect(lapsesData));
      setIndicators(toSelect(resData.map(x => ({ ...x, name: x.description }))));
    } catch (error) {
      throw error;
    }
  }


  const addEvaluation = () => {
    setEvaluations(prev => [
      ...prev,
      { id: String(Date.now()), theme_generator: '', name: '', indicator_id: '', percentage: '', observations: '' }
    ]);
  };

  const removeEvaluation = async (id) => {
    // Si el id es un string, significa que eliminó una evaluación que aún no existe en la bd
    if (typeof id === 'string') {
      setEvaluations(prev => prev.filter(e => e.id !== id));
      return
    }

    // Si es un número, significa que eliminó una evaluación que ya existe en la bd
    try {
      setIsLoading(true);
      await TeacherTestsService.tests.destroyTest({ id });
      setIsLoading(false);
      toast.success('Evaluación eliminada con éxito');
      setEvaluations(prev => prev.filter(e => e.id !== id));
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
      setIsLoading(false);
    }

  };

  const updateEvaluation = (id, field, value) => {

    if (field === 'percentage') {
      const formattedValue = formatNumber(value);
      if (formattedValue === null) return;
      const toNumber = formatToApi(formattedValue)
      if (toNumber > 100) return;
      value = formattedValue;
    }

    // Si el id es un número, significa que el usuario está intentando editar una evaluación que ya existe en la bd
    if (typeof id === 'number') {
      setEvaluations(prev => prev.map(e => (e.id === id ? { ...e, [field]: value, isEdit: true } : e)));
      return
    }
    setEvaluations(prev => prev.map(e => (e.id === id ? { ...e, [field]: value } : e)));
  };

  const isValidForm = () => {
    if (!form.school_lapse_id) {
      toast.error('Debe indicar el lapso');
      return false
    }

    if (!form.date) {
      toast.error('Debe indicar la fecha');
      return false
    }

    if (!validateCurrentForms()) {
      toast.error('Debes completar todos los formularios');
      return false;
    }

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      setIsLoading(true);
      const data = {
        ...form,
        professor_id: user.id,
        questions: evaluations.filter(x => x.isEdit === undefined).map((x) => ({
          theme_generator: x.theme_generator,
          name: x.name,
          indicator_id: x.indicator_id,
          percentage: formatToApi(x.percentage),
          observations: x.observations,
        })),
        questionsEdit: evaluations.filter(x => x.isEdit).map((x) => ({
          id: x.id,
          theme_generator: x.theme_generator,
          name: x.name,
          indicator_id: x.indicator_id,
          percentage: formatToApi(x.percentage),
          observations: x.observations,
        }))
      }


      await TeacherTestsService.tests.createTest(data);
      toast.success("Evaluaciones guardadas correctamente");
      navigate('/class-management', { replace: true });
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getEvaluations = async () => {
    if (!form.date || !form.school_lapse_id || !form.subject_id) return;
    setIsLoading(true)
    try {
      const response = await TeacherTestsService.tests.getTests({
        professor_id: user.id,
        date: form.date,
        school_lapse_id: +form.school_lapse_id,
        subject_id: +form.subject_id
      });
      const { data, ...rest } = response;

      const questions = data?.flatMap(subject =>
        subject.tests?.flatMap(test =>
          test.questions || []
        ) || []
      );

      // Agregarle un campo que indique que la evaluación ya existe en la bd
      setEvaluations(questions.map((x) => ({
        ...x,
        isEdit: false,
        percentage: formatAmount(x.percentage),
      })));

      if (questions.length < 1) addEvaluation()
      setIsLoading(false);
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getEvaluations()
  }, [form.date, form.school_lapse_id, form.subject_id])


  useEffect(() => {
    addEvaluation()
    getSelects()
  }, [])


  return {
    form,
    onChange,
    isLoading,
    evaluations,
    addEvaluation,
    removeEvaluation,
    updateEvaluation,
    onSubmit,
    indicators,
    lapses: lapses?.filter(x => x.school_year_id === +form.school_year_id),
    currentLapse: lapses.find(x => x.value === String(form.school_lapse_id)),
  };
};

export default ClassManagementCreate;
